var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 21,
    viewBox: "0 0 107 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_1332)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8169 20.8276L16.8246 5.96177H17.9511L25.0021 20.8108H29.7052L36.7597 5.96177H37.9066L37.9063 20.8276H43.5381V0.274658H33.3921L27.3804 12.5638L21.3106 0.290981L11.2113 0.323408L11.1959 20.8276H16.8169Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.467056 20.8267H6.77464V0.274658H0.467056V20.8267Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7795 0.274658L44.6473 20.8276H51.386L53.149 17.3321H65.7403L67.4579 20.8276H74.2129L64.0752 0.274658H54.7795ZM59.7497 4.94672H59.1295L55.2939 12.7307H63.5426L59.7497 4.94672Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8126 0.274658H75.9838L83.8859 9.92076L74.4501 20.8276H82.7953L89.1447 13.4015L95.4227 20.8276H103.741L94.3594 9.91151L102.216 0.274658H94.5266L89.091 6.95223L83.8126 0.274658Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.017 1.77685C106.017 2.64075 105.338 3.34208 104.5 3.34208C103.662 3.34208 102.982 2.64075 102.982 1.77685C102.982 0.914151 103.663 0.21228 104.5 0.21228C105.338 0.21228 106.017 0.914151 106.017 1.77685ZM105.757 1.77685C105.757 1.06116 105.194 0.482147 104.5 0.482147C103.806 0.482147 103.243 1.06171 103.243 1.77685C103.243 2.49276 103.806 3.07221 104.5 3.07221C105.194 3.07232 105.757 2.49287 105.757 1.77685ZM104.615 1.18815H104.172V1.76238H104.623C104.679 1.76238 104.721 1.75781 104.751 1.74845C104.78 1.73953 104.81 1.72364 104.831 1.69731C104.863 1.65846 104.877 1.58207 104.877 1.4664C104.877 1.35954 104.865 1.28598 104.84 1.24898C104.821 1.22178 104.79 1.20633 104.755 1.19914C104.72 1.19185 104.672 1.18815 104.615 1.18815ZM104.671 0.909907C104.884 0.909907 105.028 0.95289 105.103 1.03864C105.171 1.11492 105.203 1.2406 105.203 1.41384C105.203 1.60264 105.178 1.72538 105.131 1.78491C105.086 1.83932 105.03 1.87675 104.926 1.89601V1.90265C105.023 1.91244 105.085 1.94193 105.131 2.00428C105.174 2.06533 105.19 2.16544 105.19 2.29199V2.59364H104.863V2.35805C104.863 2.29939 104.861 2.24977 104.855 2.21136C104.85 2.17295 104.835 2.14019 104.813 2.1143C104.791 2.08862 104.764 2.07131 104.733 2.0637C104.702 2.0563 104.662 2.0526 104.611 2.0526H104.578H104.172V2.59364H103.856L103.859 0.910016H104.671V0.909907Z",
    fill: "#E3E3E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_1332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105.55,
    height: 20.6153,
    fill: "white",
    transform: "translate(0.467056 0.21228)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImax);
export default __webpack_public_path__ + "static/media/imax.252d5a5d7926a3d605a1424aaaadc0d7.svg";
export { ForwardRef as ReactComponent };